import { useState, useEffect } from 'react';
import worksheetService from '../../services/worksheetService';
function useRegex() {
    const [regex, setRegex] = useState([]);
    const { getRegex } = worksheetService;
    async function setUpRegex() {
        const [response, errors] = await getRegex()
        if (errors != null) {
            console.log(errors)
            return;
        }
        setRegex(response.data);
    }
    
    useEffect(() => {
        setUpRegex();
    },[]);

    return {regex};
}

export default useRegex;